import React from "react";

const OvertimePolicyAllocations = () => {
    return <div>Overtime Policy Allocations</div>;
};

export default OvertimePolicyAllocations;